// Configurações para autenticação social
export const socialAuthConfig = {
  // URLs base
  backendUrl: process.env.REACT_APP_BACKEND_URL || 'http://localhost:8000',
  frontendUrl: process.env.REACT_APP_FRONTEND_URL || 'http://localhost:3000',
  
  // Endpoints da API
  endpoints: {
    googleSignup: '/auth/social/google/signup/',
    googleLogin: '/auth/social/google/login/',
    googleCallback: '/auth/social/google/callback/', // Nova rota unificada de callback
    facebookAuthUrl: '/auth/social/frontend/auth-url/facebook/', // Manter para compatibilidade
    callback: '/auth/social/frontend/callback/', // Manter para compatibilidade
  },
  
  // Configurações de redirecionamento
  redirects: {
    success: '/', // Página após login bem-sucedido
    error: '/inicio/login', // Página em caso de erro
    callback: '/auth/social/google/callback', // Página de callback para Google OAuth2
  },
  
  // Timeouts
  timeouts: {
    redirectDelay: 2000, // Delay antes do redirecionamento (ms)
    loadingTimeout: 30000, // Timeout para operações de loading (ms)
  },
  
  // Mensagens
  messages: {
    google: {
      loading: 'Conectando com Google...',
      success: 'Login com Google realizado com sucesso!',
      error: 'Erro ao conectar com Google',
    },
    facebook: {
      loading: 'Conectando com Facebook...',
      success: 'Login com Facebook realizado com sucesso!',
      error: 'Erro ao conectar com Facebook',
    },
    general: {
      loading: 'Processando autenticação...',
      error: 'Erro inesperado durante a autenticação',
      retry: 'Tentar novamente',
      goHome: 'Ir para o início',
    },
  },
};

// Função para obter URL completa de um endpoint
export const getFullUrl = (endpoint: string): string => {
  return `${socialAuthConfig.backendUrl}${endpoint}`;
};

// Função para obter URL de callback completa
export const getCallbackUrl = (): string => {
  return `${socialAuthConfig.frontendUrl}${socialAuthConfig.redirects.callback}`;
};

// Função para validar se as configurações estão corretas
export const validateConfig = (): boolean => {
  return !!(
    socialAuthConfig.backendUrl &&
    socialAuthConfig.frontendUrl &&
    socialAuthConfig.endpoints.googleSignup &&
    socialAuthConfig.endpoints.googleLogin &&
    socialAuthConfig.endpoints.googleCallback &&
    socialAuthConfig.endpoints.facebookAuthUrl &&
    socialAuthConfig.endpoints.callback
  );
};
